var exports = {
  "Q": "xe564cbfb--19586a--content",
};

module.exports = exports;
